document.addEventListener('DOMContentLoaded', () => {

    const topLinksContainer = document.querySelector('.wfc-top-links');

    /* ==========================
       TOP LINKS
    ========================== */

    const allTopLinks = window.WHATSAPP_TOP_LINKS || [];

    if (topLinksContainer) {

        const fragment = document.createDocumentFragment();

        allTopLinks.forEach(link => {

            const a = document.createElement('a');

            a.href = link.url;
            a.className = 'wfc-top-item';
            a.textContent = link.text;

            fragment.appendChild(a);

        });

        topLinksContainer.appendChild(fragment);

    }

    /* ==========================
       CLICKS
    ========================== */

    document.addEventListener('click', e => {

        /* ======================
           WHATSAPP
        ====================== */

        const whatsappBtn = e.target.closest('.wfc-item:not(.wfc-email-item)');

        if (whatsappBtn) {

            const wrapper = whatsappBtn.closest('.wfc-list');

            const number = (
                wrapper?.dataset.number || ''
            ).replace(/\D/g, '');

            if (!number) return;

            const message = encodeURIComponent(
                whatsappBtn.dataset.message || ''
            );

            window.open(
                `https://wa.me/${number}?text=${message}`,
                '_blank'
            );

            return;
        }

        /* ======================
           EMAIL
        ====================== */

        const emailBtn = e.target.closest('.wfc-email-item');

        if (emailBtn) {

            const email = emailBtn.dataset.email || '';
            const subject = encodeURIComponent(
                emailBtn.dataset.subject || ''
            );

            const body = encodeURIComponent(
                emailBtn.dataset.body || ''
            );

            window.location.href =
                `mailto:${email}?subject=${subject}&body=${body}`;
        }

    });

});